import { client } from './client'

export default {
  index () {
    return client.get('/film-formats')
  }
}



// WEBPACK FOOTER //
// ./src/api/filmformat.js